import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { timer } from 'rxjs';

import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasNotificationService } from '../gas-notify.service';
import { GasNotification } from '../gas-notify.namespace';
import { fadeInOutAnimation } from '../../../core/animations/fade-in-out.animation';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=2995%3A33884 */
@UntilDestroy()
@Component({
  selector: 'gas-notify-toast',
  templateUrl: './gas-notify-toast.component.html',
  styleUrls: ['./gas-notify-toast.component.scss'],
  animations: [
    fadeInOutAnimation,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasNotifyToastComponent implements AfterViewInit {
  @ViewChild('host')
  public hostRef: ElementRef;

  @Input()
  public notification: GasNotification.Notification;

  @HostBinding('class')
  @Input()
  public get type(): string {
    return `_${this.notification.type}`;
  }

  @HostBinding('@fadeInOutAnimation')
  public animation = true;

  public get closeIconName(): string {
    return this.notification.type.includes('light')
      ? GasIcon.Notifications.LightClose
      : GasIcon.Notifications.Close;
  }

  public get iconName(): GasIcon.Notifications {
    return GasNotification.getIcon(this.notification.type);
  }

  constructor(
    private gasNotificationService: GasNotificationService,
  ) { }

  public ngAfterViewInit(): void {
    if (!this.notification?.clickClose) {
      this.autoCloseToast();
    }

    if (typeof this.hostRef?.nativeElement?.scrollIntoView === 'function') {
      this.hostRef.nativeElement.scrollIntoView();
    }
  }

  public close(): void {
    this.gasNotificationService.closeToastNotification(this.notification.id);
  }

  public executeCallback(): void {
    this.notification.linkCallback();
    this.close();
  }

  private autoCloseToast(): void {
    timer(5000)
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => this.close());
  }

}
